import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Container } from '@mui/material';
import ReportTemplateEditor from './ReportTemplateEditor';
import { REPORT_TYPES } from './config';
import MainLayout from '../../../components/layout/MainLayout';

const ReportSettingsPage: React.FC = () => {
  const { type } = useParams<{ type: string }>();

  // Check if type exists in config
  if (!type || !REPORT_TYPES[type]) {
    // If not a valid type, maybe redirect to a list or dashboard
    return <Navigate to="/system-settings" replace />;
  }

  return (
    <MainLayout>
      <Container maxWidth="xl">
        <ReportTemplateEditor reportTypeKey={type} />
      </Container>
    </MainLayout>
  );
};

export default ReportSettingsPage;
